export default "__VITE_ASSET__aca4101b__"